module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red@3x-d7dd90a65c3073c83c4d5ae3edfc38b3.png";